<script>
import contactForm from './contact-form.vue';

export default {
    name: 'contactSection',

    components: {
        contactForm
    }
};
</script>

<template>
    <section
        id="contact"
        class="contact"
    >
        <div class="contact__glow contact__glow--one"></div>
        <div class="contact__glow contact__glow--two"></div>

        <div class="container">

            <div class="contact__wrapper">

                <div class="contact__info">

                    <span class="contact__subtitle">
                        {{ 'contact_eyebrow' | staticTitle }}
                    </span>

                    <h2 class="contact__title">
                        {{ 'contact_section_global' | staticTitle }}
                    </h2>

                    <div class="contact__copy">
                        <vue-marked>
                            {{ 'contact_section_global' | staticContent }}
                        </vue-marked>
                    </div>

                    <div class="contact__meta">

                        <span class="contact__meta-label">
                            DANTRIX PRO
                        </span>

                        <span class="contact__meta-line"></span>

                        <span class="contact__meta-text">
                            DESARROLLO DIGITAL
                        </span>

                    </div>

                </div>

                <div class="contact__form-wrapper">

                    <div class="contact__form-top">

                        <span class="contact__form-index">
                            {{ 'contact_form_top' | staticTitle }}
                        </span>

                        <span class="contact__form-status">
                            {{ 'contact_form_top' | staticContent }}
                        </span>

                    </div>

                     <div class="contact__form">

                        <contact-form />

                    </div>

                </div>

            </div>

        </div>
    </section>
</template>

<style lang="scss" scoped>
.contact {
    position: relative;

    padding: 6.25em 1.25em;

    background:
        radial-gradient(
            circle at 10% 20%,
            rgba(233, 81, 29, .06),
            transparent 28%
        ),
        radial-gradient(
            circle at 90% 85%,
            rgba(35, 83, 150, .12),
            transparent 30%
        ),
        var(--color-1);

    overflow: hidden;
}

.contact__glow {
    position: absolute;

    border-radius: 50%;

    pointer-events: none;

    filter: blur(5em);

    opacity: .18;

    &--one {
        top: 8%;
        left: -5em;

        width: 15em;
        height: 15em;

        background: var(--color-3);
    }

    &--two {
        right: -6.25em;
        bottom: 5%;

        width: 17.5em;
        height: 17.5em;

        background: #244D84;
    }
}

.container {
    position: relative;

    width: 100%;
    max-width: var(--container);

    margin: 0 auto;

    z-index: 2;
}

.contact__wrapper {
    display: grid;
    grid-template-columns: 1fr;

    gap: 3.4375em;

    align-items: start;
}

.contact__info {
    max-width: 38.75em;
}

.contact__subtitle {
    display: flex;
    align-items: center;

    gap: 0.875em;

    margin-bottom: 1.375em;

    color: var(--text-3);

    font-family: var(--font-tech);
    font-size: 0.75em;
    font-weight: 500;
    -letter-spacing: 0.1875em;

    text-transform: uppercase;

    &::before {
        content: "";

        width: 2.125em;
        height: 0.0625em;

        background: var(--color-3);

        box-shadow:
            0 0 0.75em
            rgba(233, 81, 29, .4);
    }
}

.contact__title {
    max-width: 43.75em;

    margin: 0 0 1.75em;

    color: var(--text-1);

    font-size: clamp(2.625em, 9vw, 5.125em);
    font-weight: 700;
    line-height: .92;
    -letter-spacing: -0.1875em;

    text-transform: uppercase;
}

.contact__copy {
    max-width: 32.5em;

    color: var(--text-2);

    font-size: 0.9375em;
    line-height: 1.8;

    ::v-deep p {
        margin: 0 0 1.125em;
    }

    ::v-deep strong {
        color: var(--text-1);
        font-weight: 600;
    }

    ::v-deep a {
        color: var(--text-3);

        transition: color .3s ease;

        &:hover {
            color: var(--text-1);
        }
    }
}

.contact__meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    gap: 0.75em;

    margin-top: 2.625em;
    padding-top: 1.375em;

    border-top: 0.0625em solid var(--border-1);
}

.contact__meta-label,
.contact__meta-text {
    font-family: var(--font-tech);
    font-size: 0.625em;
    -letter-spacing: 0.125em;

    text-transform: uppercase;
}

.contact__meta-label {
    color: var(--text-1);
}

.contact__meta-text {
    color: var(--text-2);
}

.contact__meta-line {
    width: 1.375em;
    height: 0.0625em;

    background: var(--color-3);
}

.contact__form-wrapper {
    position: relative;

    width: 100%;

    border: 0.0625em solid var(--border-1);

    background:
        linear-gradient(
            145deg,
            rgba(255, 255, 255, .025),
            rgba(255, 255, 255, .006)
        );

    box-shadow:
        0 1.875em 5em
        rgba(0, 0, 0, .24);

    overflow: hidden;
}

.contact__form-wrapper::before {
    content: "";

    position: absolute;

    top: 0;
    left: 0;
    right: 0;

    height: 0.125em;

    background:
        linear-gradient(
            90deg,
            transparent,
            var(--color-3),
            transparent
        );
}

.contact__form-top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 1.25em;

    padding: 1.125em 1.375em;

    border-bottom: 0.0625em solid var(--border-1);
}

.contact__form-index,
.contact__form-status {
    font-family: var(--font-tech);
    font-size: 0.625em;
    -letter-spacing: 0.1125em;

    text-transform: uppercase;
}

.contact__form-index {
    color: var(--text-2);
}

.contact__form-status {
    position: relative;

    padding-left: 0.875em;

    color: var(--text-3);

    &::before {
        content: "";

        position: absolute;

        top: 50%;
        left: 0;

        width: 0.375em;
        height: 0.375em;

        border-radius: 50%;

        background: var(--color-3);

        transform: translateY(-50%);

        box-shadow:
            0 0 0.625em
            rgba(233, 81, 29, .7);
    }
}

.contact__form {
    padding: 1.5em 1.375em 1.75em;
}

@media (min-width: 48em) {
    .contact {
        padding: 7.5em 2.5em;
    }

    .contact__form-top {
        padding: 1.25em 1.75em;
    }

    .contact__form {
        padding: 2em 1.75em 2.25em;
    }
}

@media (min-width: 61.25em) {
    .contact {
        padding: 8.75em 3.125em;
    }

    .contact__wrapper {
        grid-template-columns:
            minmax(0, .9fr)
            minmax(0, 1.1fr);

        gap: 5em;
    }

    .contact__info {
        position: sticky;

        top: 8.125em;
    }

    .contact__form {
        padding: 2.375em 2.25em 2.625em;
    }
}

@media (min-width: 87.5em) {
    .contact {
        padding-left: 4.375em;
        padding-right: 4.375em;
    }

    .contact__wrapper {
        gap: 6.875em;
    }
}
</style>